import React, { Ref } from 'react'

function _IconSimilarity(props: React.SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <g clipPath="url(#clip0_4469_13241)">
        <path
          d="M14 4H12V2C11.9997 1.73488 11.8942 1.4807 11.7068 1.29323C11.5193 1.10576 11.2651 1.0003 11 1H2C1.73488 1.0003 1.4807 1.10576 1.29323 1.29323C1.10576 1.4807 1.0003 1.73488 1 2V11C1.0003 11.2651 1.10576 11.5193 1.29323 11.7068C1.4807 11.8942 1.73488 11.9997 2 12H4V14C4.0003 14.2651 4.10576 14.5193 4.29323 14.7068C4.4807 14.8942 4.73488 14.9997 5 15H14C14.2651 14.9997 14.5193 14.8942 14.7068 14.7068C14.8942 14.5193 14.9997 14.2651 15 14V5C14.9997 4.73488 14.8942 4.4807 14.7068 4.29323C14.5193 4.10576 14.2651 4.0003 14 4ZM2 11V2H11V4H5C4.73488 4.0003 4.4807 4.10576 4.29323 4.29323C4.10576 4.4807 4.0003 4.73488 4 5V11H2ZM11 11H9.70705L5 6.293V5H6.29295L11.0006 9.7078L11 11ZM5 7.70705L8.29295 11H5V7.70705ZM11.0005 8.2935L7.70705 5H11L11.0005 8.2935ZM5 14V12H11C11.2651 11.9997 11.5193 11.8942 11.7068 11.7068C11.8942 11.5193 11.9997 11.2651 12 11V5H14V14H5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4469_13241">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconSimilarity = React.forwardRef(_IconSimilarity)
